import { FormCounter } from '@fiverr-private/forms';

export default FormCounter;
